"use strict";

/**
 * Mini-Engine für die Partner-Seite
 */

var _ = require('underscore');
var Backbone = require('backbone');
var ajax = require('ajax');

var MiniTimer = require('MiniTimer')
var getQueryParameters = require('queryparams');
var Registry = require('registry');

var ResultView = require('./views/ResultView');
var ProductsView = require('./views/ProductsView');
var ReservaTimeTable = require('./ReservaTimeTable');
var ReservaTimeTableYear = require('./ReservaTimeTableYear');
var ReservaPriceTable = require('reserva/pricetable');
var getQueryParameters = require('queryparams');


var MiniEngine = function(options) {
    _.bindAll(this, "search", "searchProducts", "updatePriceTable");
    console.log("[MiniEngine] Constructor called");

    var query = getQueryParameters();

    /* Allgemein Parameter */
    this.form = null;
    this.item = query.item || null;
    this.item_class = query.class || null;
    this.client = null;
    this.single_view = options.single_view || null;

    /* API Endpoint */
    this.api_engine = '/api/engine/';
    this.api_products = '/api/products/';

    /* Widgets */
    this.datepicker_container = null;
    this.datepicker_display = null;
    this.datepicker_fixto = null;
    this.people_container = null;
    this.people_display = null;
    this.people_fixto = null;
    this.timetable_container = null;
    this.pricetable_container = null;

    /* Did we jump to a item defined by the URL? */
    this.jumped = false;

    /* Ergebnis DOM-Node */
    this.result = null;
    this.result_products = null;
    this.dateDisplay = {};


    _.extendOwn(this, options);

    if ( typeof window.Raven !== "undefined" ) {
        Raven.setTagsContext({ app: "miniengine" });
    }

    /* Parameter Validation */
    if ( !this.single_view ) {
        var checks = [
            'form', 'result',
            'datepicker_container', 'datepicker_display',
            'people_container', 'people_display',
        ];
        for(var i = 0, field; field = checks[i]; ++i) {
            if ( !this[field] ) {
                throw new Error("[MiniEngine] Argument " + field + " is null but required");
            }
            if ( !this[field].length ) {
                throw new Error("[MiniEngine] Argument " + field + " is empty (missing DOM element?)");
            }
        }
    }

    /* Initialize app */
    this.app = new ReservaApp({
        item: this.item,
        client: this.client,
        config: options.config || {},
    });

    if ( getQueryParameters().from ) {
        this.app.formModel.setFromQueryString();
    } else {
        this.app.formModel.setFromLocalStorage();
        this.app.formModel.bindToLocalStorage();
    }

    /* Initialize widgets */
    if ( !this.single_view || this.single_view === "booking" ) {
        this.app.initializeDatepicker(this);
        this.app.initializePeopleSelect(this);

        this.initializeModelsAndViews();
        this.app.updatePeopleDisplay();


        /* Submit form on select_mode == none */
        this.app.formModel.on('change:select_mode', function(e) {
            console.log("*** Event: change:select_mode");
            if ( e.attributes.select_mode === "none" ) {
                this.app.hideDatepicker();
                this.search().catch(this.app.promiseError);
            }
        }.bind(this));

        /* Submit form on any date selection */
        this.app.on('DatePicker.dateSelected', function() {
            console.log("*** Event: DatePicker.dateSelected");
            if ( this.app.formModel.get("rooms") === 0 ) {
                this.app.formModel.set("rooms", 1);
            }
            this.search().catch(this.app.promiseError);
            this.searchProducts().catch(this.app.promiseError);
        }.bind(this));

        /* Redirect DOM submit events to our search */
        this.form.on('submit', function(e) {
            console.log("*** Event: submit");
            e.preventDefault();
            this.search().catch(this.app.promiseError);
            this.searchProducts().catch(this.app.promiseError);
        }.bind(this));

        /* If we got an item, load the valid days first (possible race condition). */
        if ( this.item || this.client ) {
            console.log("[MiniEngine] Loading days and executing searches");
            this.app.loadItemDays();
            this.search().catch(this.app.promiseError);
            this.searchProducts().catch(this.app.promiseError);
        } else {
            console.log("[MiniEngine] Executing searches without days");
            this.search().catch(this.app.promiseError);
            this.searchProducts().catch(this.app.promiseError);
        }
    }

    if ( !this.single_view || this.single_view === "timetable" ) {
            if ( this.timetable_container ) {
                this.initializeTimeTable();
            }
        }
};


MiniEngine.prototype.initializeModelsAndViews = function() {
    /* Results: Model + View */
    this.resultsModel = new Backbone.Model({
        result: null,
        item: this.item,
        error: null,
        isLoading: true,
    });
    this.resultsView = new ResultView({
        model: this.resultsModel,
        el: this.result,
    });
    this.resultsView.render();

    this.resultsModel.on("resetItem", function(e) {
        this.item = null;
        this.resultsModel.set("item", null);
        this.productsModel.set("item", null);

        this.search().catch(this.app.promiseError);
        this.searchProducts().catch(this.app.promiseError);
    }.bind(this));

    /* Products: Model + View */
    this.productsModel = new Backbone.Model({
        products: null,
        item: null,
        error: null,
        isLoading: true,
    });
    this.productsView = new ProductsView({
        model: this.productsModel,
        el: this.result_products,
    });
    this.productsView.render();
};


            /*************
             * Timetable *
             *************/


MiniEngine.prototype.initializeTimeTable = function() {
    if ( !this.timetable_container || this.timetable_container.length === 0 ) {
        console.warn("MiniEngine: timetable_container is invalid, disabling module");
        return;
    }

    ajax({
        url: '/api/engine/timetable/',
        params: _.extend(this.app.formModel.getForm(), {
            client: this.client,
            //item: this.item,
        }),
    }).then(response => {

        if ( response.classes.length === 1 && Registry.get("MiniEngine.UseTimeTableYear") ) {

            this.dateDisplay = new ReservaTimeTableYear({
                container: this.timetable_container,
                model: this.app.formModel,
            });

        } else {

            this.dateDisplay = new ReservaTimeTable({
                container: this.timetable_container,
                model: this.app.formModel,
            });

        }

        if ( !this.single_view ) {

            this.dateDisplay.on("dateSelected", function(from, to) {
                this.app.formModel.set("select_mode", "exact");

                this.app.datepicker.setFrom(from.format("YYYY-MM-DD"));
                this.app.datepicker.setTo(to.format("YYYY-MM-DD"));

                $('html, body').animate({
                    scrollTop: this.datepicker_display.offset().top - 80,
                }, 600, function() {
                    this.search().catch(this.app.promiseError);
                    this.searchProducts().catch(this.app.promiseError);
                }.bind(this));

            }.bind(this));

        }

        let dateDisplay = this.dateDisplay;
        let params = this.app.queryParameters;
        if ( params.renderDaysCount ) dateDisplay.set("renderDaysCount", parseInt(params.renderDaysCount, 10));
        if ( params.renderOffset ) dateDisplay.set("renderOffset", parseInt(params.renderOffset, 10));

        dateDisplay.init();
        dateDisplay.handleResponse(response);

    }).catch(this.app.promiseError);
};

MiniEngine.prototype.showResultTimeTable = function(options) {
    let { klass, item, container } = options;

    container.html("Einen Moment bitte...");

    ajax({
        url: '/api/engine/timetable/',
        params: {
            client: this.client,
            item: item,
        },
    }).then(response => {

        // Server responds always with all classes
        response.classes = response.classes.filter(c => c.id == klass);

        let dateDisplay = this.dateDisplay[klass] = new ReservaTimeTableYear({
            container: container,
            model: this.app.formModel,
        });

        dateDisplay.init();
        dateDisplay.handleResponse(response);

    }).catch(this.app.promiseError);
};

            /**************
             * Pricetable *
             **************/


MiniEngine.prototype.initializePriceTable = function() {
    if ( !this.pricetable_container || this.pricetable_container.length === 0 ) {
        console.warn("MiniEngine: pricetable_container is invalid, disabling module");
        return;
    }

    if ( this.pricetable ) {
        this.pricetable_container.show();
        this.updatePriceTable();
        return;
    }

    this.pricetable = new ReservaPriceTable({
        container: this.pricetable_container,
        model: this.app.formModel,
    });
    this.pricetable.run();

    this.app.formModel.on('pricetableClick', function(data) {
        this.app.formModel.set({
            from: data.from,
            to: data.to,
        });

        $('html, body').animate({
            scrollTop: this.datepicker_display.offset().top - 80,
        }, 600, function() {
            this.search().catch(this.app.promiseError);
            this.searchProducts().catch(this.app.promiseError);
        }.bind(this));

    }.bind(this));

    this.updatePriceTable();
};

MiniEngine.prototype.updatePriceTable = function() {
    this.pricetable_container.show();

    var payload = this.app.formModel.getForm();
    payload.notfound = 1;
    payload.client = this.client;
    payload.lang = window.Tramino.lang;

    /* Legacy IBE API @todo */
    var payload = {
        client: this.client,
        notfound: 1,
        item: this.item,
        from: this.app.formModel.get("from"),
        to: this.app.formModel.get("to"),
        erwachsene: this.app.formModel.get("rooms.1.adults"),
        kinder: this.app.formModel.get("rooms.1.children"),
        kind1: this.app.formModel.get("rooms.1.child1"),
        kind2: this.app.formModel.get("rooms.1.child2"),
        kind3: this.app.formModel.get("rooms.1.child3"),
    };

    ajax({
        url: "/api/engine/pricetable/",

        /*
        params: _.extend(this.app.formModel.getForm(), {
            client: this.client,
            item: this.item,
        }),
        */

        params: payload, /* @todo */
    }).then(function(response) {
        if ( response.groups.length > 0 ) {
            this.pricetable.handleResponse(response);
        }
    }.bind(this));
};


            /***********
             * Classes *
             ***********/


MiniEngine.prototype.search = function() {
    this.app.hideDatepicker();
    this.app.hidePeopleSelect();

    var params = this.app.formModel.getForm();
    params.item = this.item;
    params.class = this.item_class;
    params.lang = window.Tramino.lang;

    this.resultsModel.set({
        result: null,
        error: null,
        isLoading: true,
    });

    return ajax({
        url: this.api_engine,
        params: params,
    }).then(function(response) {

        if ( response.status && response.status === "error" ) {
            this.resultsModel.set({
                error: response.message,
                isLoading: false,
            });
        } else {

            if ( this.pricetable_container ) {
                console.log("[MiniEngine] Hiding pricetable first");
                this.pricetable_container.hide();
            }
            if ( this.pricetable_container && this.pricetable_container.length > 0 ) {
                console.log("[MiniEngine] this.initializePriceTable()");
                this.initializePriceTable();
            }

            let result = response.results[0] || null;
            let first_timetable = null;
            if ( result && result.classes ) {
                if ( result.classes.length === 1 ) {
                    // Spezialmodus für nur eine Wohnung:
                    // - Ersten Belegungsplan direkt ausklappen
                    // - Globalen Belegungsplan nicht anzeigen

                    first_timetable = {
                        klass: result.classes[0].id,
                        container: $( $('.show-result-timetable').data('for') ),
                    };

                    this.timetable_container.hide();
                    $('#detail-belegung').hide(); // ReservaPartner template
                } else {
                    this.timetable_container.show();
                    $('#detail-belegung').show(); // ReservaPartner template
                }
            }

            this.resultsModel.set({
                result: result,
                error: null,
                isLoading: false,
            });

            if ( first_timetable ) {
                // @todo This is horrible
                $('.show-result-timetable').click();
            }

            if ( this.item_class && !this.jumped ) {
                setTimeout(function() {
                    var offset = $('.class[data-class="' + this.item_class + '"]').offset();
                    if ( offset && offset.top ) {
                        $('html,body').animate({
                            scrollTop: offset.top - 150,
                        });
                    }
                }.bind(this), 100);
                this.jumped = true;
            }
        }

    }.bind(this)).catch(function(e) {
        this.resultsModel.set({
            error: e.statusText || e.message || e.error || e.toString(),
            isLoading: false,
        });
    }.bind(this)).catch(this.app.promiseError);
};


            /***********
             * Products *
             ***********/


MiniEngine.prototype.searchProducts = function() {
    var params = this.app.formModel.getForm();
    params.item = this.item;
    params.class = this.item_class;
    params.lang = window.Tramino.lang;

    this.productsModel.set({
        products: null,
        error: null,
        isLoading: true,
    });
    
    return ajax({
        url: this.api_products,
        params: params,
    }).then(function(response) {

        if ( response.status && response.status === "error" ) {
            this.productsModel.set({
                error: response.message,
                isLoading: false,
            });
        } else {
            this.productsModel.set({
                products: response.items || null,
                error: null,
                isLoading: false,
            });
        }

    }.bind(this)).catch(function(e) {
        this.productsModel.set({
            error: e.statusText || e.message || e.error || e.toString(),
            isLoading: false,
        });
    }.bind(this)).catch(this.app.promiseError);

};


MiniEngine.prototype.setItem = function(item) {
    this.resultsModel.set("item", item);
    this.productsModel.set("item", item);
    this.app.set("item", item);
    return this.app.loadItemDays();
};



module.exports = MiniEngine;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/miniengine/main.js
 **/